import { call, put, takeLatest } from 'typed-redux-saga'
import {
	commonPPSlice,
	INIVATE_TYPE,
	inivateApi,
	InivateNS,
	inivateSlice,
	leadSlice,
	SECTIONS,
} from 'Pages/partnerProfile'

function* getPartnerNew(action: InivateNS.GetPartnerNew) {
	try {
		yield* put(commonPPSlice.actions.setIsLoading(true))
		const res = yield* call(inivateApi.getPartnerNew, action.payload)
		yield* put(inivateSlice.actions.setPartnerNew(res))
	} catch (errors) {
		const { inivate_type = INIVATE_TYPE.NEW } = action.payload
		if (inivate_type === INIVATE_TYPE.NEW)
			yield* put(leadSlice.actions.setErrorsLead(errors?.data?.errors?.[0]))
	} finally {
		yield* put(commonPPSlice.actions.setIsLoading(false))
		yield* put(commonPPSlice.actions.setSection(SECTIONS.INFO))
	}
}

export function* inivateSaga() {
	yield* takeLatest(inivateSlice.actions.getPartnerNew.type, getPartnerNew)
}
